import type React from "react";

export const PRINT_SHOW = "PRINT_SHOW";
export const PRINT_DONE = "PRINT_DONE";

interface PrintShowAction {
    type: typeof PRINT_SHOW;
    content: React.ReactNode;
    system: boolean;
    onComplete: () => void;
}

interface PrintDoneAction {
    type: typeof PRINT_DONE;
}

export type PrintActionTypes = PrintShowAction | PrintDoneAction;

export interface PrintState {
    print: boolean | React.ReactNode;
    system: boolean;
    onComplete: boolean | (() => void);
}

// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = (): void => {};

export function printContent(
    content: React.ReactNode,
    system = false,
    onComplete: () => void = noop
): PrintActionTypes {
    return {
        type   : PRINT_SHOW,
        content: content,
        system : system,
        onComplete,
    };
}
